import { useFeatureFlagEnabled } from '@/features/flags/posthog-compat';

/**
 * Form editor: per-field "Fill from transcript" toggle (exclude_from_fill).
 * Lives in a sibling .ts file (not index.tsx) so the hook export doesn't add a
 * react-refresh/only-export-components warning — see the React Refresh ratchet.
 *
 * PostHog-backed (`useFeatureFlagEnabled`) so the rollout can be ramped and
 * targeted from PostHog. Rollout/kill gate, NOT an experiment — do not add
 * useManualExposure.
 */
export const useIsExcludeFormFieldsFromFillEnabled = () => {
  return useFeatureFlagEnabled('release-growth-exclude-form-fields-from-fill') ?? false;
};
